import React, { useEffect } from 'react';
import './OTPInputCodePassword.css';

const OTPInputCodePassword = ({ codeOTP, setCodeOTP }) => {
    const handleChange = (e, index) => {
        const val = e.target.value.replace(/\D/, '');

        if (!val) return;

        const newCode = [...codeOTP];
        newCode[index] = val;
        setCodeOTP(newCode);

        const next = e.target.nextSibling;
        if (next && val) next.focus();
    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            if (codeOTP[index]) {
                const newOtp = [...codeOTP];
                newOtp[index] = '';
                setCodeOTP(newOtp);
            } else if (index > 0) {
                const prevInput = document.getElementById(`otp-input-${index - 1}`);
                prevInput?.focus();
            };
        };
    };

    const handlePaste = (e, index) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData('text').replace(/\D/g, '');
        if (!pasted) return;

        const currentCode = [...codeOTP];

        for (let i = 0; i < pasted.length && index + i < codeOTP.length; i++) {
            currentCode[index + i] = pasted[i];
        };

        setCodeOTP(currentCode);

        const nextIndex = Math.min(index + pasted.length, codeOTP.length - 1);
        const inputs = document.querySelectorAll('.otp-input');
        inputs[nextIndex]?.focus();
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === 'z') {
                e.preventDefault();
            };
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    return (
        <div className="d-flex justify-content-center gap-2 otp-container">
            {Array.from({ length: codeOTP.length }).map((_, index) => (
                <input
                    key={`OTP_input_${index}`}
                    id={`otp-input-${index}`}
                    type="text"
                    inputMode="numeric"
                    autoComplete="off"
                    maxLength="1"
                    className="form-control otp-input text-center"
                    value={codeOTP?.[index] || ''}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onPaste={(e) => handlePaste(e, index)}
                />
            ))}
        </div>
    );
};

export default OTPInputCodePassword;
